import api from 'src/spintr/SpintrApi';
import {
    FETCH_GROUP,
    SET_IS_FOLLOWING,
    JOIN_GROUP,
    LEAVE_GROUP,
    INCREMENT_UNREAD,
    CLEAR_UNREAD,
    GROUP_MEMBER_COUNT_UPDATED
} from './group-action-types';

export const findGroupById = (id) => ({
    meta: { id },
    payload: api.get(`/api/groups/${id}`),
    type: FETCH_GROUP
})

export const setIsFollowing = (id, isFollowing) => ({
    meta: {
        id,
        isFollowing
    },
    type: SET_IS_FOLLOWING
})

export const joinGroup = (id) => ({
    meta: {
        id
    },
    type: JOIN_GROUP
})

export const leaveGroup = (id) => ({
    meta: {
        id
    },
    type: LEAVE_GROUP
})

export const incrementUnread = () => ({
    type: INCREMENT_UNREAD
})

export const clearUnread = () => ({
    type: CLEAR_UNREAD
})

export const fetchGroupMembers = (groupId: number) => {
    return async (dispatch) => {
        try {
            const response = await api.get('/api/v1/groupmembers', {
                params: { groupId }
            });

            const members = response.data.members
            .map((m) => ({
                ...m,
                imageUrl: m.image,
            }))
            .sort((a, b) => a.instanceId - b.instanceId || a.name.localeCompare(b.name));            

            dispatch({
                type: GROUP_MEMBER_COUNT_UPDATED,
                payload: {
                    groupId,
                    members: members,
                    membersCount: response.data.memberCount
                }
            });
        } catch (error) {
            console.error("Failed to fetch group members:", error);
        }
    };
};
